if (typeof window.structuredClone !== "function") {
  window.structuredClone = (v) =>
    v === undefined ? v : JSON.parse(JSON.stringify(v));
}

if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value: function (fn) {
      return [...this].sort(fn);
    },
    writable: true,
    configurable: true,
  });
}